import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=488647a4&scoped=true"
import script from "./TextSection.vue?vue&type=script&lang=js"
export * from "./TextSection.vue?vue&type=script&lang=js"
import style0 from "./TextSection.vue?vue&type=style&index=0&id=488647a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488647a4",
  null
  
)

export default component.exports